import React, { useLayoutEffect } from 'react';
import { ownerify } from '../../utils/portedPlace';

// 💬 The place page's chat line (PORTED_HOME_HANDOFF_2026_09_25 W2d.1, "A9";
// the look is mockup v9's .lane .msg): a quiet bubble with three things in
// it, the name, the words, and his 💭 line. No initials avatar, no model id,
// no "(Human Player)", no status line (the caption already says it), no
// "Turn N". The time is ALWAYS visible (wave 2b, Nina 09-26: small, after
// the name, on every line; the bubble's title keeps the full date form).
// His name is pink, "you" is amber and sits right, anyone else is cream.
// The owner's 🔍/📌 (PlaceLineTools) ride INSIDE the bubble, as in the mockup.
//
// Page-side, GameStepPage's PlaceChatLine builds the name, the words and the
// tools and hands them here; this file owns only the look. It mounts ONLY on
// a place page (the `placeChat` prop is null everywhere else), so every other
// room keeps today's rows byte for byte.
//
// The 😊 of any SEATED human (wave 2b, Nina 09-26: guests can react too; a
// spectator with no seat never gets one): while a line has no reactions yet
// it sits BESIDE the bubble (.pmr-qk), so it takes no
// row of its own and the lane keeps the mockup's 10px rhythm; its picker then
// anchors to the row (the lane's edge, the bubble's foot), never past it. With reactions, the
// chips and the 😊 sit under the bubble. Desktop shows the 😊 on the bubble's
// hover or focus; a phone always shows it.
//
// Class names avoid every substring the generated themes target
// ([class*='message'|'card'|'panel'|'user'|'player'|'chip'|'btn'...]; the house
// theme draws a 3px border-left on anything with "message" in its class and
// paints its hover !important), the key properties carry !important behind
// doubled selectors, and the CSS goes into <head> ONCE.
const SANS = '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif';
const SERIF = '"Iowan Old Style", "Palatino Linotype", Palatino, Georgia, serif';
export const PLACE_CHAT_CSS = `
.pmr, .pmr * { box-sizing: border-box; }
.pmr { position: relative; display: flex; flex-direction: column; align-items: flex-start; width: 100%; margin: 0; padding: 0 0 10px; text-align: left; font-family: ${SERIF}; }
.pmr.pmr-me { align-items: flex-end; }
.pmr.pmr-qk { flex-direction: row; align-items: flex-end; }
.pmr.pmr-qk.pmr-me { flex-direction: row-reverse; }
.pmr.pmr-qk .pmr-af { flex: none; padding: 0 6px 2px; }
.pmr.pmr-qk .pmr-af > div { position: static !important; }
.pmr.pmr-qk .pmr-pk.pmr-pk { bottom: 10px !important; }
.pmr .pmr-b.pmr-b { position: relative; display: block; max-width: 80%; min-width: 0; margin: 0 !important; padding: 9px 13px !important; border-radius: 14px !important; background: rgba(255,246,235,.06) !important; border: 1px solid rgba(255,236,210,.1) !important; box-shadow: none !important; text-shadow: none !important; font-family: ${SERIF}; color: rgba(255,241,224,.93); overflow-wrap: anywhere; word-break: break-word; }
.pmr .pmr-b.pmr-b:hover { background: rgba(255,246,235,.06) !important; border-color: rgba(255,236,210,.1) !important; }
.pmr.pmr-me .pmr-b.pmr-b, .pmr.pmr-me .pmr-b.pmr-b:hover { background: rgba(240,172,85,.12) !important; border-color: rgba(240,172,85,.26) !important; }
.pmr .pmr-by { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin: 0 0 4px; font: 700 .72rem/1 ${SANS}; letter-spacing: .02em; color: #E39BAB; }
.pmr.pmr-me .pmr-by { color: #F0AC55; }
.pmr.pmr-oth .pmr-by { color: rgba(255,238,216,.72); }
.pmr .pmr-tm { margin-left: 2px; font: 500 .62rem/1 ${SANS}; letter-spacing: 0; color: rgba(255,238,216,.42); font-variant-numeric: tabular-nums; white-space: nowrap; }
.pmr .pmr-mt { font: 700 .62rem/1 ${SANS}; color: #9fb6c9; border: 1px solid rgba(120,150,175,.45); border-radius: 999px; padding: 2px 6px; letter-spacing: 0; }
.pmr .pmr-tx { margin: 0; font-family: ${SERIF}; font-size: 1rem; line-height: 1.45; color: rgba(255,241,224,.93); }
.pmr .pmr-tx.pmr-em { font-style: italic; color: rgba(255,238,216,.72); }
.pmr .pmr-th { margin-top: 5px; font-family: ${SERIF}; font-style: italic; font-size: .83rem; line-height: 1.4; color: rgba(255,238,216,.46); }
.pmr .pmr-b .pwl { padding: 0; }
.pmr .pmr-b.pmr-pin::after { content: '📌'; position: absolute; top: -9px; right: -6px; font-size: 15px; filter: drop-shadow(0 2px 2px rgba(0,0,0,.5)); }
.pmr .pmr-b.pmr-new { animation: pmrRise .5s ease-out; }
.pmr .pmr-af { display: flex; align-items: center; gap: 6px; min-height: 0; padding: 2px 4px 0; }
.pmr .pmr-af button { border: 0 !important; box-shadow: none !important; text-shadow: none !important; transform: none !important; }
.pmr .pmr-af .pmr-add.pmr-add { opacity: .6 !important; }
@media (hover: hover) and (min-width: 768px) {
  .pmr .pmr-af .pmr-add.pmr-add { opacity: 0 !important; }
  .pmr:hover .pmr-af .pmr-add.pmr-add, .pmr:focus-within .pmr-af .pmr-add.pmr-add { opacity: .6 !important; }
  .pmr .pmr-af .pmr-add.pmr-add:hover, .pmr .pmr-af .pmr-add.pmr-add:focus-visible { opacity: 1 !important; }
}
@keyframes pmrRise { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
@media (max-width: 767px) {
  .pmr .pmr-b.pmr-b { max-width: 88%; }
  .pmr .pmr-tx { font-size: .9rem; }
}
@media (prefers-reduced-motion: reduce) { .pmr .pmr-b.pmr-new { animation: none; } }
`;
const STYLE_ID = 'ported-chat-rows-css';

// Idempotent, and re-checks the node (a test or a theme swap can clear <head>).
export function ensurePlaceChatStyle(doc = (typeof document !== 'undefined' ? document : null)) {
  try {
    if (!doc || !doc.head || doc.getElementById(STYLE_ID)) return;
    const s = doc.createElement('style');
    s.id = STYLE_ID;
    s.textContent = PLACE_CHAT_CSS;
    doc.head.appendChild(s);
  } catch (e) { /* unstyled rows still read */ }
}

// The rows this bubble draws: plain spoken lines only. Private, secret, ghost,
// house and sub-chat lines, and any row carrying a stage direction or a diary
// room (never in a ported room), keep today's renderer.
const PLACE_CHAT_TYPES = new Set(['public_message', 'human_interjection', 'message', 'speak']);
export function isPlaceChatLine(action) {
  if (!action || !PLACE_CHAT_TYPES.has(action.type)) return false;
  const d = action.data || {};
  if (d.sub_conversation_message === true || d.parent_action_id) return false;
  if (d.stage_direction || d.diary_room) return false;
  return true;
}

// Whose line this is, and the one name the bubble prints: "you" for the
// viewer's own seat, the resident by his seat (else by sender_name, when the
// roster has no seat to match), anyone else by their seat name. A name only:
// never the seat's model ("claude-sonnet-4.5", "Human Player").
export function placeLineWho(action, { user = null, humanPlayerId = null, residentSeatId = null, residentName = null } = {}) {
  const d = (action && action.data) || {};
  const pid = action && action.game_instance_player_id ? String(action.game_instance_player_id) : null;
  if (pid && humanPlayerId && pid === String(humanPlayerId)) return { who: 'me', name: 'you' };
  const isRes = pid && residentSeatId ? pid === String(residentSeatId) : (!!residentName && d.sender_name === residentName);
  const name = (isRes && residentName) || (user && user.name) || d.sender_name || 'Someone';
  return { who: isRes ? 'resident' : 'other', name: String(name) };
}

// His 💭 line, in the words the journal uses: "the user" / "my human" become
// the owner's first name (portedPlace.ownerify, zero LLM). Never a pronoun.
export function placeThought(text, ownerName = null) {
  const t = typeof text === 'string' ? text.trim() : '';
  if (!t) return null;
  const out = ownerify(t, ownerName).trim();
  return out || null;
}

// The ⋯ item that keeps the thoughts switch on a place page (Nina 09-26: "you
// can keep the thought bubble toggle"): his name when the page knows it, else
// plain words. Never a pronoun. The icon (💭) is the menu's own column. (An
// OFF is remembered on this device under localStorage 'portedThoughtsOff'.)
export function placeThoughtsLabel(on, residentName = null) {
  const who = typeof residentName === 'string' ? residentName.trim() : '';
  return `${on ? 'Hide' : 'Show'} ${who ? `${who}'s thoughts` : 'thoughts'}`;
}

// Reactions on the place page (Nina 09-26: "only show reactions if kenley
// adds them, and keep them for me to use too"; then ruling 31: GUESTS CAN
// REACT): the resident's seat, the owner's seat and every other SEAT in the
// room (`seatIds`, the roster). A spectator id (no seat) never counts.
// Reactions are stored per seat id.
export function placeReactions(reactions, { residentSeatId = null, ownerSeatId = null, seatIds = null } = {}) {
  const out = {};
  if (!reactions || typeof reactions !== 'object') return out;
  const keep = new Set([residentSeatId, ownerSeatId].filter(Boolean).map(String));
  if (seatIds && typeof seatIds.forEach === 'function') seatIds.forEach((id) => { if (id) keep.add(String(id)); });
  Object.keys(reactions).forEach((k) => {
    if (!keep.has(k) || /^spectator_/.test(k)) return;
    const list = reactions[k];
    if (!Array.isArray(list)) return;
    const kept = list.filter((e) => typeof e === 'string' && e);
    if (kept.length) out[k] = kept;
  });
  return out;
}

// 💭 The swap rule (ruling 31, A9): "the user" becomes the owner's name ONLY
// when the newest human line BEFORE his row is the OWNER's (in a shared room
// "the user" may mean a guest). Rows run oldest → newest; a human line is a
// plain spoken line from any seat but his. No human line before = no swap.
export function ownerSpokeBefore(actions, index, { residentSeatId = null, ownerSeatId = null } = {}) {
  if (!Array.isArray(actions) || !ownerSeatId) return false;
  const res = residentSeatId ? String(residentSeatId) : null;
  for (let i = Math.min(index, actions.length) - 1; i >= 0; i -= 1) {
    const a = actions[i];
    if (!a || !isPlaceChatLine(a)) continue;
    const d = a.data || {};
    const seat = a.game_instance_player_id || d.sender_id || null;
    if (!seat || (res && String(seat) === res) || d.is_moderator) continue;
    return String(seat) === String(ownerSeatId);
  }
  return false;
}

// 🃏 Media card BODIES on the place page (wave 2b, leftover 1): the room theme's
// light surfaces (a tan doodle card on the dark lane) give way to the lane's
// own dark ground. One derived theme per room theme (a WeakMap: identity is
// stable across renders, so memoized cards hold). The accent stays the room's.
const PLACE_CARD_THEMES = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
export function placeCardTheme(theme) {
  if (!theme || typeof theme !== 'object') return theme;
  const hit = PLACE_CARD_THEMES && PLACE_CARD_THEMES.get(theme);
  if (hit) return hit;
  const out = {
    ...theme,
    bgLight: '#1B1522',
    bgMedium: '#160F1C',
    borderLight: 'rgba(255,236,210,.14)',
    textMuted: 'rgba(255,238,216,.62)',
    textColor: 'rgba(255,241,224,.93)',
    textOnPanel: 'rgba(255,241,224,.93)',
    textOnPanelMuted: 'rgba(255,238,216,.55)',
    textBright: '#FFF1E0',
    textDark: '#FFF1E0',
  };
  if (PLACE_CARD_THEMES) PLACE_CARD_THEMES.set(theme, out);
  return out;
}

// The rise plays only for a line under 20 s old: the virtual feed remounts
// rows by index as you scroll, and an old line must never rise again.
export const PLACE_FRESH_MS = 20000;
export function isFreshLine(ts, nowMs = Date.now()) {
  const t = typeof ts === 'number' ? ts : Date.parse(ts || '');
  if (!Number.isFinite(t) || t <= 0) return false;
  const age = nowMs - t;
  return age > -60000 && age < PLACE_FRESH_MS;
}

export default function PlaceChatRow({
  who = 'other',      // 'resident' | 'me' | 'other'
  name = '',          // the resident's / the other person's name ("you" is written here)
  tag = null,         // a small node after the name (the 🔧 maintainer pill)
  body = null,        // the words (a node)
  emote = false,      // "* name waves *" reads in italics
  thought = null,     // his 💭 line (already in the owner's words)
  showThought = true,
  tools = null,       // the owner's 🔍/📌, inside the bubble
  after = null,       // reactions, the 🚩, under the bubble
  quick = false,      // `after` is only the viewer's 😊: it sits beside the bubble
  time = '',          // the time, always visible after the name (small)
  title = '',         // the full time, on hover
  pinned = false,
  fresh = false,
  actionId = null,
}) {
  useLayoutEffect(() => { ensurePlaceChatStyle(); }, []);
  const side = who === 'me' ? 'pmr-me' : who === 'resident' ? 'pmr-res' : 'pmr-oth';
  const th = showThought && typeof thought === 'string' && thought.trim() ? thought.trim() : null;
  const label = who === 'me' ? 'you' : (String(name || '').trim() || 'Someone');
  return (
    <div className={`pmr ${side}${quick && after ? ' pmr-qk' : ''}`} data-pmr={actionId || ''}>
      <div className={`pmr-b${pinned ? ' pmr-pin' : ''}${fresh ? ' pmr-new' : ''}`} title={title || undefined}>
        <div className="pmr-by">{label}{tag}{time ? <span className="pmr-tm" data-pmr-time="">{time}</span> : null}</div>
        <div className={`pmr-tx${emote ? ' pmr-em' : ''}`}>{body}</div>
        {th ? <div className="pmr-th">💭 {th}</div> : null}
        {tools}
      </div>
      {after ? <div className="pmr-af">{after}</div> : null}
    </div>
  );
}
